module.exports = __webpack_public_path__ + "img/none.65898316.svg";